module.exports = __webpack_public_path__ + "img/PL09191.1ac32d50.png";